import { Fragment, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { CertificatesAnpr } from 'shell/models/certificates-anpr';
import FormCertificatesAnpr, {
  CertificatesAnprForm,
} from 'system/components/certificates-anpr/form';
import { CommonCertificatesAnprCrumbs } from '../constants';
import { transformerCertificatesAnpr } from 'system/components/certificates-anpr/utils/transformer-certificates';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

const CertificatesAnprEditPage = (): React.ReactElement => {
  const params = useParams();

  const updateCertificatesAnpr = useHttpClient(
    `${__MANAGEMENT_API_URL__}/postazione-anpr/${params.id}`,
    {
      options: {
        errorCatching: true,
        method: 'PUT',
        loading: true,
        data: {},
      },
    }
  );

  const [certificate] = useHttpFetch<HttpResponse<CertificatesAnpr>, CertificatesAnprForm>(
    `${__MANAGEMENT_API_URL__}/postazione-anpr/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformerCertificatesAnpr,
    }
  );

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: CertificatesAnprForm | undefined) => {
      (
        updateCertificatesAnpr({
          data: {
            note: formValues?.contextLastUpdate || undefined,
            aliasCertificato: formValues?.alias || formValues?.code || undefined,
            certificato: formValues?.certificateUpload?.raw?.split(',')[1] || undefined,
            codicePostazioneAnpr: formValues?.certificateUpload?.file?.name || undefined,
            dataFineValidita: formValues?.endValidityDate?.toFormat('yyyy-MM-dd'),
            dataInizioValidita: formValues?.startValidityDate?.toFormat('yyyy-MM-dd'),
            password: formValues?.password,
            key: {
              codice: params.id,
            },
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/certificati-postazione');
      });
    },
    [updateCertificatesAnpr, navigate, params]
  );

  const loadingCertificatesAnpr =
    certificate.isLoading || certificate.pristine || certificate.hasErrors;

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonCertificatesAnprCrumbs,
          {
            name: 'Modifica Certificato postazione anpr',
          },
        ]}
        base="sistema"
      />
      {loadingCertificatesAnpr ? null : (
        <FormCertificatesAnpr
          title="Modifica Certificato postazione anpr"
          onOk={onSubmit}
          onCancel={() => {
            navigate('/sistema/certificati-postazione');
          }}
          initialValues={certificate.data as CertificatesAnprForm}
        />
      )}
    </Fragment>
  );
};

CertificatesAnprEditPage.displayName = 'Certificates Anpr Edit page component';

export default CertificatesAnprEditPage;
